module.exports = __webpack_public_path__ + "static/media/logo-mutant.e282039c.svg";